import request from './request';

/**
 * Extras use Group/Value model: ExtraGroup + ExtraValue. Product.extras = array of ExtraValue ObjectIds.
 * Product form: use getAllValues() — GET dashboard/admin/extra/values (correct endpoint).
 * getExtrasList/getExtrasPaginate use legacy paths (dashboard/admin/extras) and may 404.
 */
const extraService = {
  getExtrasList: (params) =>
    request.get('dashboard/admin/extras', { params }),
  getExtrasPaginate: (params) =>
    request.get('dashboard/admin/extras/paginate', { params }),

  getAllGroups: (params) =>
    request.get('dashboard/admin/extra/groups', { params }),
  getGroupById: (id, params) =>
    request.get(`dashboard/admin/extra/groups/${id}`, { params }),
  getGroupTypes: (params) =>
    request.get('dashboard/admin/extra/groups/types', { params }),
  createGroup: (data) => request.post('dashboard/admin/extra/groups', data),
  updateGroup: (id, data) =>
    request.put(`dashboard/admin/extra/groups/${id}`, data),
  setGroupActive: (id) =>
    request.post(`dashboard/admin/extra/groups/${id}/active`),
  deleteGroup: (data) =>
    request.delete(`dashboard/admin/extra/groups/delete`, { data }),
  dropAllGroup: () => request.get(`dashboard/admin/extra/group/drop/all`),
  restoreAllGroup: () => request.get(`dashboard/admin/extra/group/restore/all`),

  getAllValues: (params) =>
    request.get('dashboard/admin/extra/values', { params }),
  getValueById: (id, params) =>
    request.get(`dashboard/admin/extra/values/${id}`, { params }),
  createValue: (data) =>
    request.post('dashboard/admin/extra/values', data),
  updateValue: (id, data) =>
    request.put(`dashboard/admin/extra/values/${id}`, data),
  setValueActive: (id) =>
    request.post(`dashboard/admin/extra/values/${id}/active`),
  deleteValue: (data) =>
    request.delete(`dashboard/admin/extra/values/delete`, { data }),
  dropAllValue: () => request.get(`dashboard/admin/extra/values/drop/all`),
  restoreAllValue: () =>
    request.get(`dashboard/admin/extra/values/restore/all`),
};

export default extraService;
